import React, { createContext, useState } from 'react';
import emailjs from '@emailjs/browser';

export const CartContext = createContext();

export function CartProvider({ children }) {
  const [cart, setCart] = useState([]);

  function addToCart(item) {
    setCart(prev => {
      const idx = prev.findIndex(p => p.id === item.id && p.category === item.category);
      if (idx > -1) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + item.quantity };
        return copy;
      }
      return [...prev, item];
    });
  }

  function updateQuantity(id, category, qty) {
    setCart(prev => prev.map(i => (i.id === id && i.category === category ? { ...i, quantity: Math.max(1, qty) } : i)));
  }

  function removeItem(id, category) {
    setCart(prev => prev.filter(i => !(i.id === id && i.category === category)));
  }

  function clearCart() {
    setCart([]);
  }

  async function checkoutSendEmail(toEmail = 'sales@yourbrand.com') {
    if (cart.length === 0) return { ok: false, message: 'Cart is empty' };

    const details = cart.map(i => `Name: ${i.name} | Category: ${i.category} | Qty: ${i.quantity}`).join('\n');
    const templateParams = {
      to_email: toEmail,
      subject: 'New Perfume Purchase',
      message: details
    };

    try {
      await emailjs.send(
        import.meta.env.VITE_EMAILJS_SERVICE_ID,
        import.meta.env.VITE_EMAILJS_TEMPLATE_ID,
        templateParams,
        import.meta.env.VITE_EMAILJS_USER_ID
      );
      clearCart();
      return { ok: true };
    } catch (err) {
      return { ok: false, message: err.message || 'Email failed' };
    }
  }

  return (
    <CartContext.Provider value={{ cart, addToCart, updateQuantity, removeItem, clearCart, checkoutSendEmail }}>
      {children}
    </CartContext.Provider>
  );
}